/**
 * Feature flags — read from `.env` at build time.
 *
 * Wave 42.171 — added `SHOW_INDIVIDUAL` to hide the "For Individuals" flow
 * across the marketing site + signup selection + pricing toggle while the
 * business focuses solely on employer onboarding. Backend data (individual
 * tiers, existing individual users) is left untouched so we can flip this
 * flag back on later without any migrations.
 *
 * Env var must be the literal string `"true"` to enable. Anything else
 * (including undefined, empty, "1", "yes") is treated as OFF. This makes
 * the default deliberately safe: forget to set the flag → feature stays hidden.
 */
export const SHOW_INDIVIDUAL =
  String(process.env.REACT_APP_SHOW_INDIVIDUAL).toLowerCase() === 'true';

export default { SHOW_INDIVIDUAL };
